export default "__VITE_ASSET__BbBAF_32__"